export default __webpack_public_path__ + "static/browsermockup-4aa5c1fe73d61c7ef56c54f81ed1ce93.svg";